import updateReduxAction from '../update'
import validateReduxAction from '../validate'
import REDUX_ACTION from '../../constants/action'

/**
 * Updates the `value` at the given `payload.path` and validate the object.
 * @param {Object} params
 *        {number} params.type
 *        {Object} params.payload
 *        {string} params.payload.path
 *        {string} params.payload.value
 *        {Object} [params.payload.options]
 */
function updateAndValidateReduxAction (params) {
  return dispatch => {
    dispatch(updateReduxAction(params))
    dispatch(validateReduxAction({
      type: REDUX_ACTION.VALIDATE,
      payload: {
        ...params.payload
      }
    }))
  }
}

export default updateAndValidateReduxAction
